import { Type } from "@sinclair/typebox";
export const ComplaintStatusValues = [
    "new",
    "acknowledged",
    "in_review",
    "resolved",
    "escalated",
];
export const ComplaintStatusSchema = Type.Union([
    Type.Literal("new"),
    Type.Literal("acknowledged"),
    Type.Literal("in_review"),
    Type.Literal("resolved"),
    Type.Literal("escalated"),
]);
export const ComplaintCategoryValues = [
    "claim",
    "policy_coverage",
    "payments_cancellation_refunds",
    "customer_service",
    "app_website_experience",
    "other",
];
export const ComplaintCategorySchema = Type.Union([
    Type.Literal("claim"),
    Type.Literal("policy_coverage"),
    Type.Literal("payments_cancellation_refunds"),
    Type.Literal("customer_service"),
    Type.Literal("app_website_experience"),
    Type.Literal("other"),
]);
export const SalutationSchema = Type.Union([
    Type.Literal("mr"),
    Type.Literal("mrs"),
    Type.Literal("ms"),
]);
export const ComplaintStatusHistoryEntrySchema = Type.Object({
    status: ComplaintStatusSchema,
    changedBy: Type.String(),
    changedAt: Type.String({ format: "date-time" }),
    note: Type.Optional(Type.String()),
});
export const ComplaintAttachmentSchema = Type.Object({
    filename: Type.String(),
    url: Type.String(),
    contentType: Type.String(),
    size: Type.Number(),
});
export const ComplaintSchema = Type.Object({
    _id: Type.String(),
    referenceNumber: Type.String(),
    salutation: Type.Optional(SalutationSchema),
    complainantLastName: Type.String(),
    complainantFirstName: Type.String(),
    complainantEmail: Type.String({ format: "email" }),
    complainantPhone: Type.Optional(Type.String()),
    policyNumber: Type.Optional(Type.String()),
    policyId: Type.Optional(Type.String()),
    complaintCategories: Type.Array(ComplaintCategorySchema),
    otherCategoryDetail: Type.Optional(Type.String()),
    complaintDescription: Type.String(),
    attachments: Type.Optional(Type.Array(ComplaintAttachmentSchema)),
    privacyPolicyConsent: Type.Boolean(),
    status: ComplaintStatusSchema,
    statusHistory: Type.Array(ComplaintStatusHistoryEntrySchema),
    createdAt: Type.String({ format: "date-time" }),
    updatedAt: Type.String({ format: "date-time" }),
    resolvedAt: Type.Optional(Type.String({ format: "date-time" })),
    retainUntil: Type.String({ format: "date-time" }),
    deletedAt: Type.Optional(Type.String({ format: "date-time" })),
});
